export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6873.dcd11d71.jpg";